<script>
import Page from '@/components/elements/Page';
import PageIntro from '@/components/elements/PageIntro';
import CcButton from '@/components/elements/CcButton';
import TooBusyButton from '@/components/elements/TooBusyButton';

export default {
    name: 'VaccinationVerifyCW',
    components: { TooBusyButton, Page, PageIntro, CcButton },
    data() {
        return {
            info: null,
            tooBusy: this.$config.tooBusy,
            verificationCode: null,
            token: null
        }
    },
    methods: {
        isNumber: function(evt) {
            // evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        verifyCode() {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.$store.state.accToken}`
            }
            this.$axios
                .post(this.$config.apiacthealth + 'Personalias/VerifyVacPersonalia', { token: this.token, code: this.verificationCode },
                    { headers })
                .then(response => {
                    if (response.data === 1) {
                        this.$store.state.vaccination2FA = true;
                        this.getInformation();
                    } else {
                        this.$store.state.createDCCVerify = false;
                        this.$store.commit('modal/set', {
                            messageHead: this.$t('message.error.invalidVerificationCode.head'),
                            messageBody: this.$t('message.error.invalidVerificationCode.body', { code: '404' }),
                            closeButton: true
                        });
                    }
                })
                .catch(error => {
                    alert(error.message);
                    this.fetching = false;
                    this.$store.commit('modal/set', {
                        messageHead: this.$t('message.error.invalidVerificationCode.head'),
                        messageBody: this.$t('message.error.invalidVerificationCode.body', { code: error }),
                        closeButton: true
                    });
                    this.errored = true
                })
        },
        getInformation() {
            this.$axios
                .post(this.$config.apiacthealth + 'Personalias/GetVacPersonalia', { token: this.token, code: this.verificationCode }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.$store.state.accToken}`
                    }
                })
                .then(response => {
                    this.$store.state.createDCCVerify = true;
                    this.info = JSON.parse(response.data);
                    if (this.info) {
                        const pVaccinations = this.info;
                        const holder = {
                            firstName: this.info.nam.fn,
                            lastName: this.info.nam.gn,
                            birthDate: this.info.dob
                        }
                        this.$store.state.pVaccinations = pVaccinations;
                        this.$store.state.pHolder = holder;
                        this.$store.state.pToken = this.token;
                        this.$store.state.pVerificationCode = this.verificationCode;
                        this.$router.push({ name: 'VaccinationOverviewCW' });
                    } else {
                        alert('Error fetching information.');
                    }
                })
                .catch(error => {
                    this.$store.state.createDCCVerify = false;
                    this.$store.commit('modal/set', {
                        messageHead: this.$t('message.error.invalidVerificationCode.head'),
                        messageBody: this.$t('message.error.invalidVerificationCode.body', { code: error.response }),
                        closeButton: true
                    });
                    this.errored = true
                })
        },
        back() {
            this.$router.push({ name: 'ChoiceProofCW' })
        },
        resendVerificationCode() {
            this.$axios
                .put(this.$config.apiacthealth + 'personalias/resendVerificationCode', {
                    token: this.token,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.$store.state.accToken}`
                    }
                })
                .then(response => {
                    if (response.data === 1) {
                        this.$store.commit('modal/set', {
                            messageHead: this.$t('message.info.resendverificationCode.head'),
                            messageBody: this.$t('message.info.resendverificationCode.body'),
                            closeButton: true
                        });
                    } else {
                        this.$store.commit('modal/set', {
                            messageHead: this.$t('message.error.general.head'),
                            messageBody: this.$t('message.error.general.body'),
                            closeButton: true
                        });
                    }
                })
                .catch(error => {
                    if (error.response) {
                        const status = error.response.status;
                        switch (status) {
                        case 401:
                            alert('Error 403');
                            break;
                        case 403:
                            alert('Error 403');
                            break;
                        case 500:
                            alert('Error 403');
                            break;
                        default:
                            this.$store.commit('modal/set', {
                                messageHead: this.$t('message.error.general.head'),
                                messageBody: this.$t('message.error.general.body'),
                                closeButton: true
                            });
                        }
                    }
                })
        }
    },
    computed: {
        testCode: {
            get() {
                return this.$store.state.testCode;
            },
            set(value) {
                // editing the test code should reset the process
                this.$store.commit('resetProvideCode');
                const strippedValue = value.replace(/ /g, '');
                const strippedValue2 = strippedValue.replace(/\t/g, '');
                const toUpperCase = strippedValue2.toUpperCase();
                this.$store.commit('updateProperty', { key: 'testCode', value: toUpperCase })
            }
        }
    },
    mounted() {
        if ((this.$store.state.userConsent !== true) || (this.$store.state.pToken === '')) {
            this.$router.push({ name: 'Home' });
        }
        this.$store.state.createDCCVerify = false;
        this.token = this.$store.state.pToken;
    }
}
</script>

<template>
 <Page
        @back="back">
        <div class="section">
            <p v-if="info">{{info.nam.fn }}</p>
            <PageIntro
                :head="$t('views.VaccinationVerifyCodeCW.pageHeader')"
                :intro="$t('views.VaccinationVerifyCodeCW.pageIntro')"/>
            <div class="section-block">
                 <div class="section-block__footer">
                     <p>{{ this.$t('views.VaccinationVerifyCodeCW.subtitle') }}</p>
                     <TooBusyButton v-if="tooBusy"/>
                     <div class="input__set">
                        <input @keypress="isNumber($event)" type="text" pattern="\d*" maxlength = "6" v-model="verificationCode" id="input--testCode" :placeholder="$t('forInstanceAbbr') + ' 669977'"/>
                     </div>
                     <CcButton v-if="!tooBusy" @select="verifyCode()" :label="$t('components.verificationcode.verifycode')"/>
                </div>
            </div>
        </div>
    </Page>
</template>

<style lang="scss">
@import "@/styles/variables/index";

.ProvideTestCode {

    .UserConsent {
        margin-bottom: $length-s;
    }
}
</style>
